export default __webpack_public_path__ + "static/media/black-bell.9f6e89e3.webp";